import {firebaseApp} from "../config/firebase"
import {getFirestore, query, collection, where, getDocs, writeBatch, onSnapshot, updateDoc, doc} from "firebase/firestore"
import { getFunctions, httpsCallable } from "firebase/functions";
import { logError } from "../utils/errorHandlingUtils"
import { DAY_IN_MILLISECONDS } from "../constants/datetime";
import {PAYOUT_STATUS_CANCELLED, PAYOUT_STATUS_CREATED, PAYOUT_STATUS_READY_TO_PAY} from "../constants/payouts"
export const SAVE_PAYOUTS = 'SAVE_PAYOUTS'
export const UPDATE_PAYOUT = 'UPDATE_PAYOUT'

export const savePayouts = payouts => {
    return {
        type: SAVE_PAYOUTS,
        payload: {
            payouts
        }
    }
}

export const updatePayout = (id, update) => {
    return {
        type: UPDATE_PAYOUT,
        payload: {
            id,
            update
        }
    }
}

export const fetchSaveUnpaidAdminPayouts = () => {
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = query(collection(firestore, "payouts"), where("paid", "==", false))
    return async (dispatch) => {
        try{
            const querySnapshot = await getDocs(payoutsRef)
            //get an array of products from the snapshot
            const payouts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
            dispatch(savePayouts(payouts))
            return true
        } catch (e){
            const message = `action > payouts > fetchSaveUnpaidAdminPayouts: Failed to save payouts`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSaveOpenAdminPayouts = () => {
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = query(collection(firestore, "payouts"), where("closedAt", "==", null))
    return async (dispatch) => {
        try{
            const querySnapshot = await getDocs(payoutsRef)
            //get an array of products from the snapshot
            const payouts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
            dispatch(savePayouts(payouts))
            return true
        } catch (e){
            const message = `action > payouts > fetchSaveOpenAdminPayouts: Failed to save payouts`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSaveCancelledUnsettledAdminPayouts = () => {
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = query(
        collection(firestore, "payouts"), 
        where("disbursementId", "==", null),
        where("currentStatus", "==", PAYOUT_STATUS_CANCELLED)
    )
    return async (dispatch) => {
        try{
            const querySnapshot = await getDocs(payoutsRef)
            //get an array of products from the snapshot
            const payouts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
            dispatch(savePayouts(payouts))
            return true
        } catch (e){
            const message = `action > payouts > fetchSaveCancelledUnsettledAdminPayouts: Failed to save payouts`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSaveSellerPayouts = sellerId => {
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = query(collection(firestore, "payouts"), where("payeeId", "==", sellerId))
    return async (dispatch) => {
        try{
            const payoutsListener = await onSnapshot(payoutsRef,
                querySnapshot =>{
                    //get an array of products from the snapshot
                    const payouts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
                    dispatch(savePayouts(payouts))
                }
            )
            return payoutsListener
        } catch (e){
            const message = `action > payouts > fetchSaveSellerPayouts: Failed to save payouts`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSaveDeliveryProviderPayouts = deliveryProviderId => {
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = query(collection(firestore, "payouts"), where("payeeId", "==", deliveryProviderId))
    return async (dispatch) => {
        try{
            const payoutsListener = await onSnapshot(payoutsRef,
                querySnapshot =>{
                    //get an array of products from the snapshot
                    const payouts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
                    dispatch(savePayouts(payouts))
                }
            )
            return payoutsListener
        } catch (e){
            const message = `action > payouts > fetchSaveDeliveryProviderPayouts: Failed to save payouts`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSaveAdminPayoutsInDateRange = (
    fromDate = Date.now() - (DAY_IN_MILLISECONDS * 30),//defaults to listening to all payouts placed in the last 30 days
    toDate=Date.now()
) => {
    /**
      * Purpose: retrieve the payouts from the firestore database created between the specified date range
      * Note: the onSnapshot below watches for changes to the center on the server
      */
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = query(collection(firestore, "payouts"), 
                            where("createdAt", ">=",  fromDate),
                            where("createdAt", "<=", toDate))                          
    return async dispatch => {
        try {
            const payoutsListener = await onSnapshot(payoutsRef,
                querySnapshot => {
                    //get an array of payouts from the snapshot
                    const payouts = querySnapshot.docs.map(docRef => ({...docRef.data()}));
                    dispatch(savePayouts(payouts))
                } 
            )
            return payoutsListener
        } catch (e){
            const message = `action > payouts > fetchSaveAdminPayoutsInDateRange: Failed to save payouts from ${fromDate} to ${toDate}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const callCancelPayout = (
    payoutId="", 
    onSuccess = () => {}
) => {
    const functions = getFunctions();
    return async (dispatch) => {
        try {
        const cancelPayout = httpsCallable(functions, "cancelPayout");
        const result = await cancelPayout({ payoutId });

        if (result.data.success) {
            const update = result.data.update
            dispatch(updatePayout(payoutId, update));
            onSuccess();
        }

        return true
        } catch (e) {
            const message = `action > payouts > callCancelPayout: Failed to cancel payout ${payoutId}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    };
};

export const fetchSetPayoutNotReady = (
    payoutId,
    onSuccess=()=>{}
) => {
    /**
      * Purpose: set a payout which is READY TO PAY to CREATED
      */
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = doc(firestore, "payouts", payoutId)   
    const update = {
        currentStatus: PAYOUT_STATUS_CREATED,
        readyAt: null
    }                  
    return async (dispatch, getState) => {
        try {
            const {user} = getState()
            update.lastEditedAt = Date.now()
            update.lastEditedByUserId = user.id
            await updateDoc(payoutsRef, update)
            dispatch(updatePayout(payoutId, update))
            onSuccess(update)
            return true
        } catch (e){
            const message = `action > payouts > fetchSetPayoutNotReady: Failed to set payout ${payoutId} to CREATED: ${JSON.stringify(update)}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSetPayoutReadyToPay = (
    payoutId,
    onSuccess=()=>{}
) => {
    /**
      * Purpose: set a payout which is CREATED to READY TO PAY
      */
    const firestore = getFirestore(firebaseApp)
    const payoutsRef = doc(firestore, "payouts", payoutId)   
    const update = {
        currentStatus: PAYOUT_STATUS_READY_TO_PAY,
        readyAt: Date.now()
    }                  
    return async (dispatch, getState) => {
        try {
            const {user} = getState()
            update.lastEditedAt = Date.now()
            update.lastEditedByUserId = user.id
            await updateDoc(payoutsRef, update)
            dispatch(updatePayout(payoutId, update))
            onSuccess(update)
            return true
        } catch (e){
            const message = `action > payouts > fetchSetPayoutReadyToPay: Failed to set payout ${payoutId} to READY TO PAY: ${JSON.stringify(update)}`
            if (e.message_){
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            return false
        }
    }
}

export const fetchSetBulkPayoutsReadyStatus = (
    payoutIds = [],
    readyToPay = false,
    onSuccess = () => {}
) => {
    /**
     * Purpose: set multiple READY TO PAY payouts to CREATED if no ready, and from CREATED to READY TO PAY otherwise 
     */
    const firestore = getFirestore(firebaseApp);

    return async (dispatch, getState) => {
        try {
            const { user } = getState();

            const batchLimit = 400;
            const batchArray = [writeBatch(firestore)];
            let batchIndex = 0;
            let operationCount = 0;

            const update = readyToPay ? 
            {
                currentStatus: PAYOUT_STATUS_READY_TO_PAY,
                readyAt: Date.now()
            }           
            :      
            {
                currentStatus: PAYOUT_STATUS_CREATED,
                readyAt: null,
            };

            update.lastEditedAt = Date.now()
            update.lastEditedByUserId = user.id
            for (let i = 0; i < payoutIds.length; i++) {
                const batch = batchArray[batchIndex];
                const payoutRef = doc(firestore, "payouts", payoutIds[i]);

                batch.update(payoutRef, update);

                operationCount++;

                if (operationCount >= batchLimit && i < payoutIds.length - 1) {
                    batchArray.push(writeBatch(firestore));
                    batchIndex++;
                    operationCount = 0;
                }
            }

            let processed = 0;

            for (const batch of batchArray) {
                const count = batch._mutations ? batch._mutations.length : batchLimit;

                await batch.commit();

                const start = processed;
                const end = Math.min(processed + count, payoutIds.length);

                for (let i = start; i < end; i++) {
                    dispatch(updatePayout(payoutIds[i], update));
                }

                processed = end;
                console.log(`Updated ${processed} of ${payoutIds.length} payouts`);
            }

            onSuccess(update);
            return true;
        } catch (e) {
            const message = `action > payouts > fetchSetBulkPayoutsReadyStatus: Failed to set ${payoutIds.length} payouts' ready status to ${readyToPay}`;

            if (e.message_) {
                logError(new Error(`${e.message} ${message}`));
            } else {
                e.message = `${e.message} ${message}`;
                logError(e);
            }

            return false;
        }
    };
};